import { isSupportedBrowser, nativeAPIInit } from '@el5/native-api'

import { addAppRequestInterceptor } from './api/mobile'
import { initSentry } from './sentry/sentry'

export function init() {
  initSentry()

  if (isSupportedBrowser()) {
    nativeAPIInit()
  }

  addAppRequestInterceptor()
}
